import Fluxible from 'fluxible';
import Application from './components/Application';
import ApplicationStore from './stores/ApplicationStore';
import RouteStore from './stores/RouteStore';
import WebsiteStore from './stores/WebsiteStore';
import WebsitelandingStore from './stores/WebsitelandingStore';
import ServiceentityStore from './stores/ServiceentityStore';
import ProductentityStore from './stores/ProductentityStore';
import LoginStore from './stores/LoginStore';
import HomeStore from './stores/HomeStore';
import ServiceStore from './stores/ServiceStore';
import ProductStore from './stores/ProductStore';
import UserProfileStore from './stores/UserProfileStore';
import UserfavouriteStore from './stores/UserfavouriteStore';
import fetchrPlugin from 'fluxible-plugin-fetchr';
import facebookPlugin from 'fluxible-plugin-facebook';
import AutoCompleteStore from './stores/AutoCompleteStore';
import EntertainerResultStore from './stores/EntertainerResultStore';
import ResultsStore from './stores/ResultsStore';
import OffersStore from './stores/OffersStore';

// create new fluxible instance
const app = new Fluxible({
  component: Application
});
app.plug(fetchrPlugin({
  xhrPath: '/api'
}));
app.plug(facebookPlugin({
  appId: 298445360330246
}));
// register stores
app.registerStore(RouteStore);
app.registerStore(ApplicationStore);
app.registerStore(WebsiteStore);
app.registerStore(HomeStore);
app.registerStore(ServiceStore);
app.registerStore(ProductStore);
app.registerStore(UserProfileStore);
app.registerStore(UserfavouriteStore);
app.registerStore(WebsitelandingStore);
app.registerStore(ServiceentityStore);
app.registerStore(ProductentityStore);
app.registerStore(LoginStore);
app.registerStore(LoginStore);
app.registerStore(AutoCompleteStore);
app.registerStore(EntertainerResultStore);
app.registerStore(ResultsStore);
app.registerStore(OffersStore);

module.exports = app;



// WEBPACK FOOTER //
// ./src/app.js